(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('action-rms-update-list-filter-record', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options, eventData, actionResponse) {
            var args = arguments;
            return $q.when(run());
            function run() {
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                console.log('action-rms-update-list-filter-record', args);
                // return true;
                return listFilterService.updateRecord(actionResponse.record);
            }
        };
    }
})();
